export default {
  GET_ONE_FLAT(state) {
    // const { area, ...rest } = state.single_flat
    // const new_area = {}
    // Object.keys(area).forEach(el => {
    //   new_area[el] = area[el].value
    // })
    // return {
    //   ...rest,
    //   area_fields: area,
    //   area: new_area,
    // }
    return state.single_flat
  },
  GET_FLATS: state => state.flats.results,
  GET_FLATS_COUNT: state => state.flats.count,
  GET_FLATS_PLANNINGS: state => state.flat_plannings,
  GET_FLAT_TYPES: state => state.flat_types,
  GET_FLAT_CHARACTERISTIC: state => state.characteristic.results,
  GET_FLAT_PERCENTAGES: state => state.flatPercentages,
}